import { create } from 'zustand'
import type { TheaterId, TerrainCell } from '@fleetduel/shared'

/**
 * Theater selection state (GDD-v3 §2).
 * Chosen on the Theater Select screen, consumed when creating a game
 * and by the board renderers for terrain display.
 *
 * Terrain layouts are randomized server-side per game and per board;
 * they arrive with `room_joined` and override the static config.
 */
export interface TheaterStore {
  theaterId: TheaterId
  terrainEnabled: boolean
  /** Server-issued layout for the player's own board (null until room_joined) */
  ownTerrain: TerrainCell[] | null
  /** Server-issued layout for the enemy board */
  enemyTerrain: TerrainCell[] | null

  setTheater: (id: TheaterId) => void
  setTerrainEnabled: (enabled: boolean) => void
  setTerrainLayouts: (own: TerrainCell[] | null, enemy: TerrainCell[] | null) => void
}

export const useTheaterStore = create<TheaterStore>((set) => ({
  // Hormuz is the default (and currently only) playable theater; terrain
  // is always on. Other theaters are teased as "coming soon".
  theaterId: 'hormuz',
  terrainEnabled: true,
  ownTerrain: null,
  enemyTerrain: null,

  setTheater: (theaterId) => set({ theaterId, ownTerrain: null, enemyTerrain: null }),
  setTerrainEnabled: (terrainEnabled) => set({ terrainEnabled }),
  setTerrainLayouts: (ownTerrain, enemyTerrain) => set({ ownTerrain, enemyTerrain }),
}))
